import BaseService from '../../BaseService.js'

export default class ExportService extends BaseService {

  constructor() {
    super('export')
  }

  async getVerbrauch(startDate, endDate) {
    await this.retrieveBackendUrl();
    return this.checkError(
      fetch(`${this.backendUrl}/verbrauch?from=${startDate}&to=${endDate}`, {
        method: 'GET',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    )
  }

  async getVerbrauchprognose(startDate, endDate) {
    await this.retrieveBackendUrl();
    return this.checkError(
      fetch(`${this.backendUrl}/verbrauch-prognose?from=${startDate}&to=${endDate}`, {
        method: 'GET',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    )
  }

  async getNominierteLeistungEinspeisepunkt(startDate, endDate) {
    await this.retrieveBackendUrl();
    return this.checkError(
      fetch(`${this.backendUrl}/nominierte-leistung-einspeisepunkt?from=${startDate}&to=${endDate}`, {
        method: 'GET',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    )
  }

  async getNominierteLeistungTransitleitung(startDate, endDate) {
    await this.retrieveBackendUrl();
    return this.checkError(
      fetch(`${this.backendUrl}/nominierte-leistung-transitleitung?from=${startDate}&to=${endDate}`, {
        method: 'GET',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    )
  }

  async getMeterdatenEinspeisepunkt(startDate, endDate) {
    await this.retrieveBackendUrl();
    return this.checkError(
      fetch(`${this.backendUrl}/meterdaten-einspeisepunkt?from=${startDate}&to=${endDate}`, {
        method: 'GET',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    )
  }

  async getMeterdatenTransitleitung(startDate, endDate) {
    await this.retrieveBackendUrl();
    return this.checkError(
      fetch(`${this.backendUrl}/meterdaten-transitleitung?from=${startDate}&to=${endDate}`, {
        method: 'GET',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    )
  }

  async getAngebot(startDate, endDate) {
    await this.retrieveBackendUrl();
    return this.checkError(
      fetch(`${this.backendUrl}/angebot?from=${startDate}&to=${endDate}`, {
        method: 'GET',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    )
  }

  async getTemperaturdaten(startDate, endDate) {
    await this.retrieveBackendUrl();
    return this.checkError(
      fetch(`${this.backendUrl}/temperaturdaten?from=${startDate}&to=${endDate}`, {
        method: 'GET',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    )
  }

}
